/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodViewTabsEnum {
    PERIODS = 'PERIODS',
    BUNDLES = 'BUNDLES',
    SETTLEMENTS = 'SETTLEMENTS',
}
